export const joints_angles = [
    //Thumb
    [118, 232],
    [93, 193],
    [78, 160],
    //index
    [120, 136],
    [113, 101],
    [114, 66],
    //Middle
    [148, 136],
    [152, 93],
    [152, 64],
    //Ring
    [172, 145],
    [179, 104],
    [185, 70],
    //Pinky
    [197, 160],
    [213, 128],
    [225, 107]
]
export const tips_distance = [
    [228,66],
    [159,13],
    [112,18],
    [64,57]
]
export const tips_angles = [
    [207,77],
    [150,21],
    [104,25],
    [62,60]
]